import { createContext } from "react";

export const SelectContext = createContext<{ size: "md" | "sm" }>({
	size: "sm",
});
